module.exports = __webpack_public_path__ + "media/images/emblems/Saules-coat_of_arms-4728c25d7a7e132a180b718ccf4e1bc3.svg";